export default "__VITE_PUBLIC_ASSET__80927d53__"